<style lang="scss" scoped>
  .container {
    margin: 0 auto;
    padding: 0 20px;
    width: 1060px;
    max-width: 100%;
  }

  .title {
    margin: 0 0 40px;
    font-size: 44px;
    line-height: 1.09;
    font-weight: 600;
    letter-spacing: 0.005em;

    @include media(max, lg) {
      margin-bottom: 30px;
      font-size: 32px;
      line-height: 1.12;
    }
  }

  .tools-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include media(max, lg) {
      justify-content: center;
    }

    @media screen and (max-width: 768px) {
      display: block;
    }
  }

  .tools-item {
    margin-bottom: 24px;
    padding: 32px 476px 32px 32px;
    line-height: 1.33;
    color: #333;
    width: 100%;
    min-height: 218px;
    background: #eaf1f9 no-repeat 100% 0;
    background-size: auto 100%;
    border-radius: 20px;
    overflow: hidden;
    flex: 1 0 100%;

    &:last-child {
      margin-bottom: 0;
    }

    @include media(max, lg) {
      margin: 0 15px 30px;
      padding: 178px 16px 20px;
      max-width: 335px;
      background-size: contain;
      width: 100%;
      background-position: 50% 0;
    }

    &:nth-child(2n) {
      padding: 32px 32px 32px 476px;
      background-position: 0 0;

      @include media(max, lg) {
        padding: 178px 16px 20px;
        background-position: 50% 0;
      }
    }

    @media screen and (max-width: 768px) {
      margin: 0 auto 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &_payment {
      background-image: cdn('images/b2b/tools/cards.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/tools/cards@2x.png');
      }

      @include media(max, lg) {
        background-image: cdn('images/b2b/tools/cards-mob.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/tools/cards-mob@2x.png');
        }
      }
    }

    &_distribution {
      background-image: cdn('images/b2b/tools/distribution.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/tools/distribution@2x.png');
      }

      @include media(max, lg) {
        background-image: cdn('images/b2b/tools/distribution-mob.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/tools/distribution-mob@2x.png');
        }
      }
    }

    &_marketing {
      background-image: cdn('images/b2b/tools/marketing.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/tools/marketing@2x.png');
      }

      @include media(max, lg) {
        background-image: cdn('images/b2b/tools/marketing-mob.png');

        @media (-webkit-min-device-pixel-ratio: 2),
        (min-resolution: 192dpi) {
          background-image: cdn('images/b2b/tools/marketing-mob@2x.png');
        }
      }
    }
  }

  .tools-title {
    margin: 0 0 12px;
    font-size: 30px;
    line-height: 1.13;
    font-weight: 700;
    letter-spacing: 0.005em;
    color: #000;

    @include media(max, lg) {
      font-size: 24px;
      line-height: 1.17;
    }
  }

  .tools-descr {
    font-size: 18px;
    line-height: 1.33;
    font-weight: 400;

    @include media(max, lg) {
      font-size: 16px;
      line-height: 1.38;
    }

    li {
      position: relative;
      padding-left: 28px;

      &:before {
        content: '\2022';
        position: absolute;
        top: 0;
        left: 9px;
      }

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 28px;

        &:before {
          left: auto;
          right: 9px;
        }
      }
    }
  }
</style>

<template>
  <div class="container">
    <h2 class="title">
      {{$t('title')}}
    </h2>

    <div class="tools-list">
      <div class="tools-item tools-item_payment">
        <h3 class="tools-title">
          {{$t('payment.title')}}
        </h3>
        <ul class="tools-descr">
          <li>{{$t('payment.text1')}}</li>
          <li>{{$t('payment.text2')}}</li>
          <li>{{$t('payment.text3')}}</li>
        </ul>
      </div>

      <div class="tools-item tools-item_distribution">
        <h3 class="tools-title">
          {{$t('distribution.title')}}
        </h3>
        <ul class="tools-descr">
          <li>{{$t('distribution.text1')}}</li>
          <li>{{$t('distribution.text2')}}</li>
          <li>{{$t('distribution.text3')}}</li>
        </ul>
      </div>

      <div class="tools-item tools-item_marketing">
        <h3 class="tools-title">
          {{$t('marketing.title')}}
        </h3>
        <ul class="tools-descr">
          <li>{{$t('marketing.text1')}}</li>
          <li>{{$t('marketing.text2')}}</li>
          <li>{{$t('marketing.text3')}}</li>
        </ul>
      </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

export default {
  name: 'Tools',
  i18n: {
    messages: {
      ru: {
        title: 'Инструменты',
        payment: {
          title: 'Приём платежей',
          text1: 'Широкий набор методов оплаты',
          text2: 'Собственная служба анти-фрода',
          text3: 'Комиссия за приём платежей включена в комиссию платформы.',
        },
        distribution: {
          title: 'Система дистрибуции',
          text1: 'Высокая скорость доставки дистрибутивов и обновлений пользователю',
          text2: 'Эффективные алгоритмы подготовки патчей минимального размера',
          text3: 'Стоимость раздачи включена в комиссию платформы.',
        },
        marketing: {
          title: 'Маркетинг',
          text1: 'Инструменты для продвижения вашей игры: каталоги, подборки, нотификаторы, спецпроекты',
          text2: 'Платформа для email рассылок с высокими показателями открываемости',
          text3: 'Экспертная поддержка специалистов VK Play.',
        },
      },
      en: {
        title: 'Tools',
        payment: {
          title: 'Payment Processing',
          text1: 'A wide variety of payment methods',
          text2: 'In-house anti-fraud service',
          text3: 'Payment commission is included in the platform’s commission',
        },
        distribution: {
          title: 'Distribution System',
          text1: 'High-speed delivery of distributions and updates to users',
          text2: 'Effective, compact patch prep algorithms',
          text3: 'The price of distribution is included in the platform’s commission',
        },
        marketing: {
          title: 'Marketing',
          text1: 'Tools to promote your game: catalogs, selections, notifications, special projects',
          text2: 'A platform for email newsletters with high openability rates',
          text3: 'Expert support from VK Play specialists',
        },
      },
      de: {
        title: 'Werkzeuge',
        payment: {
          title: 'Zahlungsabwicklung',
          text1: 'Eine Vielzahl verschiedener Zahlungsmethoden',
          text2: 'Betriebsinterner Dienst zum Schutz vor Betrug',
          text3: 'Zahlungsgebühren in der Plattformgebühr inkludiert',
        },
        distribution: {
          title: 'Distributionssystem',
          text1: 'Lieferung von Distributionen und Updates zu den Nutzern in Top-Geschwindigkeit',
          text2: 'Effektiver, kompakter Patch-Vorbereitungsalgorithmus',
          text3: 'Distributionsgebühren in der Plattformgebühr inkludiert',
        },
        marketing: {
          title: 'Marketing',
          text1: 'Werkzeuge zur Bewerbung Ihres Spiels: Kataloge, Sammlungen, Benachrichtigungen, Spezialprojekte',
          text2: 'Eine Plattform für E-Mail-Newsletter mit hoher Leserate',
          text3: 'Experten-Support durch VK Play-Spezialisten',
        },
      },
      fr: {
        title: 'Outils',
        payment: {
          title: 'Traitement des paiements',
          text1: 'Une grande variété de moyens de paiement',
          text2: 'Service interne anti-fraude',
          text3: 'La commission du paiement est comprise dans la commission de la plateforme',
        },
        distribution: {
          title: 'Système de distribution',
          text1: 'Livraison rapide des distributions et des mises à jour aux utilisateurs',
          text2: 'Algorithmes de préparation de patch efficaces et compacts',
          text3: 'Le prix de la distribution est compris dans la commission de la plateforme',
        },
        marketing: {
          title: 'Marketing',
          text1: 'Des outils pour promouvoir votre jeu : catalogues, sélection, notifications, projets spéciaux',
          text2: 'Une plateforme pour les newsletters par e-mail avec des taux d\'ouverture élevés',
          text3: 'Assistance experte des spécialistes de VK Play',
        },
      },
      es: {
        title: 'Herramientas',
        payment: {
          title: 'Procesamiento de pagos',
          text1: 'Una gran variedad de métodos de pago',
          text2: 'Servicio antifraude incorporado',
          text3: 'La comisión de pago se incluye en la comisión de la plataforma',
        },
        distribution: {
          title: 'Red de distribución',
          text1: 'Entrega rápida de distribuciones y actualizaciones para los usuarios',
          text2: 'Algoritmos para preparar parches efectivos y compactos',
          text3: 'El precio de distribución está incluido en la comisión de la plataforma',
        },
        marketing: {
          title: 'Publicidad',
          text1: 'Herramientas para promocionar el juego: catálogos, colecciones, notificaciones y proyectos especiales',
          text2: 'Una plataforma para boletines por correo electrónico con un índice alto de éxito',
          text3: 'Asistencia de especialistas en VK Play',
        },
      },
      pl: {
        title: 'Narzędzia',
        payment: {
          title: 'Realizacja płatności',
          text1: 'Szeroki wybór metod płatności',
          text2: 'Wewnętrzny dział ds. zwalczania nadużyć finansowych',
          text3: 'Prowizja za płatność jest uwzględniona w prowizji platformy',
        },
        distribution: {
          title: 'System dystrybucji',
          text1: 'Szybka dystrybucja i dostarczanie aktualizacji użytkownikom',
          text2: 'Skuteczne, kompaktowe algorytmy przygotowywania patchów',
          text3: 'Cena dystrybucji jest uwzględniona w prowizji platformy',
        },
        marketing: {
          title: 'Marketing',
          text1: 'Narzędzia promujące grę: katalogi, kolekcje, powiadomienia, projekty specjalne',
          text2: 'Platforma do tworzenia biuletynów e-mail o wysokim wskaźniku klikalności',
          text3: 'Wsparcie specjalistów VK Play',
        },
      },
      tr: {
        title: 'Araçlar',
        payment: {
          title: 'Ödeme İşleme',
          text1: 'Geniş bir ödeme yöntemi seçeneği',
          text2: 'Dahili sahtekârlık karşıtı hizmet',
          text3: 'Platformun komisyonu ödeme komisyonuna dahildir',
        },
        distribution: {
          title: 'Dağıtım Sistemi',
          text1: 'Kullanıcılara yüksek hızlı dağıtım teslimatı ve güncellemeler',
          text2: 'Etkili, kompakt yama hazırlık algoritmaları',
          text3: 'Dağıtım ücreti platform komisyonuna dahildir',
        },
        marketing: {
          title: 'Pazarlama',
          text1: 'Oyununu desteklemek için araçlar: Kataloglar, seçmeler, bildirimler, özel projeler',
          text2: 'Yüksek açılma oranlarına sahip e-posta bültenleri için platform',
          text3: 'VK Play uzmanlarından uzman destek',
        },
      },
      ar: {
        title: 'الأدوات',
        payment: {
          title: 'معالجة السداد',
          text1: 'مجموعة كبيرة من أساليب السداد',
          text2: 'خدمة داخلية لمكافحة الاحتيال',
          text3: 'عمولة السداد جزء من عمولة المنصة',
        },
        distribution: {
          title: 'نظام التوزيع',
          text1: 'توصيل عالي السرعة للتوزيعات والتحديثات للمستخدمين',
          text2: 'خوارزميات فعالة ومدمجة لإعداد الإصلاحات',
          text3: 'أسعار التوزيع مدرجة ضمن عمولة المنصة',
        },
        marketing: {
          title: 'التسويق',
          text1: 'أدوات للترويج للعبتك: كتالوجات ومجموعات وإشعارات ومشروعات خاصة',
          text2: 'منصة لنشرات أخبار البريد الإلكتروني مع معدلات انفتاح عالية',
          text3: 'دعم خبراء من متخصصي VK Play',
        },
      },
    },
  },
};

</script>
